<template>
    <div>        
        <b-row v-for="(item, index) in data" :key="index">
            <b-col :class="getNodeClass(item)">
                <hr v-if="showLine(item)"> 

                <div :class="getContentNodeClass(item)"> 
                    <b-link                                          
                        class='link'                                                             
                        :href="item.href"    
                        :style="item.styleLink"          
                        @click="itemClick(item, $event)" 
                        @contextmenu="nodeRightClick(item, $event)">

                        <div :style="item.styleContent">                     
                            <i v-if="Array.isArray(item[`${nameFieldChildrens}`]) && item[`${nameFieldChildrens}`].length"  
                                :class="getArrowIcon(item)" 
                                class="pr-1">
                            </i>
                            
                            <i v-if="item.icon" 
                                :class="item.icon" 
                                class="pr-1" >
                            </i>  
                            
                            <span>{{item[`${nameFieldLabel}`]}}</span>                
                        </div>
                    </b-link>
                
                    <b-collapse v-model="item._showDetails" >
                        <node 
                            :data="item[`${nameFieldChildrens}`]"
                            :nameFieldLabel="nameFieldLabel"
                            :nameFieldChildrens="nameFieldChildrens"
                            :showLineOnLeaf="showLineOnLeaf"
                            @nodeClick="nodeClick"
                            @nodeRightClick="nodeRightClick"                                                           
                        >
                        </node>  
                    </b-collapse>
                </div>
            </b-col >                             
        </b-row>
    </div>
</template>

<script>


import Node from './Node';

export default {
    name: "node",

    components: {
        Node
    },

    props: {
        data: { type: Array, default: () => [] },
        nameFieldLabel:  { type: String, default: () => 'label' },
        nameFieldChildrens:  { type: String, default: () => 'childrens' },
        showLineOnLeaf:  { type: Boolean, default: () => true },
    },


    methods: {
        itemClick(item, event){  
            if(item[`${this.nameFieldChildrens}`]){                
                this.$set(item, '_showDetails', !item._showDetails);                                                                                       
            }else{              
               this.$set(item, '_showDetails', false);    
            }
            
            this.nodeClick(item, event);
        },

        nodeClick(item, event){            
            this.$emit('nodeClick', item, event);                       
        },

        nodeRightClick(item, event){      
            this.$emit('nodeRightClick', item, event);                                                   
        },

        getArrowIcon(item){     
            return item._showDetails ? "fa fa-chevron-down" : "fa fa-chevron-right";           
        },

        getNodeClass(item){
            if(item.nodeRoot){
                return 'node-root';
            }else{
                return 'node-child';
            }
        },
      
        getContentNodeClass(item){
            if(Array.isArray(item[`${this.nameFieldChildrens}`]) && item[`${this.nameFieldChildrens}`].length){
                return 'content';
            }else{
                return 'content-leaf';
            }
        },
      
        showLine(item){ 
            if(!item[`${this.nameFieldChildrens}`]){
                return this.showLineOnLeaf;
            }
            return true;            
        },
    },
    
    mounted(){       
        this.data.forEach(item => {                
            this.$set(item, '_showDetails', item.showDetails);
        });
    }
}
</script>

<style scoped>
    .node-root .content,
    .node-root .content-leaf, 
    .node-child .content,
    .node-child .content-leaf {       
        font-size: 0.93rem;   
    }

    .node-root  {           
        margin-left: 0rem;  
        text-align: left;  
    }

    .node-child {     
        margin-left: 1.5rem; 
        text-align: left;      
    }
 
    .node-root .content .link, 
    .node-root .content-leaf .link, 
    .node-child .content .link,
    .node-child .content-leaf .link{        
        color: initial;      
    }

    .content-leaf{        
       margin-left: 0.91rem;  
    }

</style>
